/* eslint-disable react-hooks/exhaustive-deps */
import { Progress } from "antd";
import { useMemo, useState } from "react";
import "../layout/style.css";
import favicon from "../../images/logo.png";

export const XpressLoader: React.FC = (props) => {
  const [percent, setPercent] = useState(0);
  const setState = () => {
    for (let i = 1; i <= 100; i++) {
      let tick = function (percent: number) {
        return function () {
          setPercent(percent);
        };
      };
      setTimeout(tick(i), 100 * i);
    }
  };
  useMemo(() => {
    setState();
  }, []);
  return (
    <div className="grid place-content-center h-[100svh] ">
        <img
          src={favicon}
          style={{
            width: "200px",
            height: "200px",
            marginBottom: "-3rem",
          }}
          alt="loader"
        />
        <Progress percent={percent} status="active" showInfo={false} />
    </div>
  );
};
